/**
 * Singleton pour gérer l'instance du client PowerPoint
 */

import { DevanaWSClient } from "@devana/ws-tools";
import { createPowerPointClient } from "./powerPointClientLib";

let powerPointClientInstance: DevanaWSClient | null = null;

export function getOrCreatePowerPointClient(
  apiUrl: string,
  options?: {
    documentName?: string;
    bearerToken?: string;
    callbacks?: {
    onConnected?: (sessionId: string) => void;
    onReconnected?: (sessionId: string) => void;
    onDisconnected?: () => void;
    onError?: (error: Error) => void;
    onSessionsChanged?: () => void;
  }
  }
): DevanaWSClient {
  // Si le client existe déjà et est connecté, le retourner
  if (powerPointClientInstance && powerPointClientInstance.isConnected()) {
    console.log("[PowerPointClientSingleton] ♻️ Returning existing connected client");
    return powerPointClientInstance;
  }

  // Si le client existe mais n'est pas connecté, le déconnecter proprement
  if (powerPointClientInstance) {
    console.log("[PowerPointClientSingleton] 🔄 Client exists but not connected, recreating...");
    try {
      powerPointClientInstance.disconnect();
    } catch (e) {
      console.error("[PowerPointClientSingleton] Error disconnecting old client:", e);
    }
    powerPointClientInstance = null;
  }

  // Créer un nouveau client
  console.log("[PowerPointClientSingleton] 🆕 Creating new PowerPoint client");
  powerPointClientInstance = createPowerPointClient(apiUrl, options);

  // Connecter le client
  powerPointClientInstance.connect();

  return powerPointClientInstance;
}

export function disconnectPowerPointClient() {
  if (powerPointClientInstance) {
    console.log("[PowerPointClientSingleton] 🔌 Disconnecting client");
    powerPointClientInstance.disconnect();
    powerPointClientInstance = null;
  }
}

export function getPowerPointClientInstance(): DevanaWSClient | null {
  return powerPointClientInstance;
}